import { getRegions } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'regions/FETCH_START',
  FETCH_SUCCESS: 'regions/FETCH_SUCCESS',
  FETCH_ERROR: 'regions/FETCH_ERROR',
}

export const fetchRegions = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_START })

  try {
    const { data } = await getRegions()
    return dispatch({ type: actionTypes.FETCH_SUCCESS, payload: data })
  } catch (error) {
    return dispatch({ type: actionTypes.FETCH_ERROR })
  }
}
